<template>
  <div class="main-hero">
    <b-container>
      <b-row class="flex-column-reverse flex-md-row">
        <b-col
          lg="6"
          md="6"
          class="coming-soon__text"
          style="padding-bottom: 10px;"
        >
          <h1>
            <strong>
              Welcome to PonyEngine ...
            </strong>
          </h1>
          <type-text
              style="margin: 25px;"
          />
          <p style="color:black">
            At PonyEngine Inc innovation meets execution. With a legacy of over 30 years in software
            development, we've been the driving force behind groundbreaking ideas, from pioneering mobile apps to
            collaborating with industry giants like Red Bull, Disney, Heineken, Tecate, and Corso. Our team, with
            senior-level experience cultivated in military precision, is poised to transform your app concept into
            a stellar reality.
          </p>
          <p style="color:black">
            Embark on your journey with us – PonyEngine Inc is more than a development company; we're your strategic partners. To tailor our expertise to your unique needs, we invite you to set up a meeting with our seasoned professionals. Let's delve into your vision, refine the documentation, and pave the way for a project that not only meets but exceeds expectations. Your success story begins with PonyEngine Inc. Schedule a meeting today, and let's bring your app idea to life!
          </p>
          <b-button pill
                    variant="dark"
                    @click="handleMeetingRequest">
            Let's Discuss
          </b-button>
          <social-media style="margin-top: 15px"/>
        </b-col>
        <b-col lg="6" md="6" class="banner-img">
                <video-vimeo
                    :video-id="174270265"
                    :loop="false"
                />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import SocialMedia from "@/components/home/SocialMedia";
import TypeText from "./typeText";
import VideoVimeo from "../_rowComponents/videoVimeo";

export default {
  name: "Intro_About",
  components: {
    SocialMedia,
    TypeText,
    VideoVimeo
  },
  methods: {
    getEarlyAccess() {
      this.error = "";
      if (!this.validateEmail(this.email)) {
        this.error = "Please Enter a valid email!";
        return;
      }
      this.$emit("applied", this.email);
      this.email = "";
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    logEvent(evt) {
      console.log(evt)

      // Here you can handle the emitted events with custom code
      if (evt === "calendly.profile_page_viewed") {
        console.log("Calendly profile has been opened")
      }
    },
    handleMeetingRequest(){
      window.open(this.meetingURL, "_blank");
    },
    handleLogEvent(){}
  },
  data() {
    return {
      meetingURL:"https://calendly.com/ponyengine/app-discussion",
      email: "",
      error: ""
    };
  }
};
</script>

<style lang="scss" scoped>
.single {
  max-width: 600px;
  width: 100%;
  // height: 134px;

  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 45px;
  line-height: 120%;
  /* or 67px */

  /* Body */

  color: #222222;
}
.coming-soon__text {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.main-hero {
  //background: url("../../assets/img/home/hero.svg") no-repeat center center;
  //background-size: cover;
  background-color: #ffc728;
  h3 {
    font-style: normal;
    font-weight: bold;
    font-size: 40px;
    line-height: 55px;
    color: #0d0d21;
    display: flex;
    column-gap: 15px;
    margin-bottom: 16px;
    span {
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 27px;
      display: flex;
      align-items: center;
      color: #ffcc4d;
      margin-top: -5px;
    }
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: #f3f6f9;
    margin-bottom: 30px;
  }
  .input-email {
    display: flex;
    justify-content: center;
    column-gap: 8px;
    min-height: 50px;
    & > div {
      width: 100%;
    }
    .error {
      display: inline-block;
      margin-bottom: 6px;
      font-size: 12px;
      margin-left: 10px;
      color: #fff;
    }
    .form-control {
      padding: 12px 27px;
      height: 40px;
      border-radius: 20px;
      border: 1px solid #fff;
      &:focus {
        outline: none;
        border: 1px solid #fff;
      }
      &::-webkit-input-placeholder {
        /* Edge */
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }

      ::placeholder {
        font-size: 12px;
        line-height: 16px;
        color: #8d99a0;
      }
    }
    .btn-success {
      background: #010610;
      border-radius: 32px;
      height: 40px;
      font-style: normal;
      font-weight: bold;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      padding: 12px 16px;
      min-width: 150px;
      &:after,
      &:before {
        content: none;
      }
    }
  }
  img {
    margin: 40px 0;
  }
}
@media (min-width: 992px) {
  .banner-img {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 25px;
  }
}
@media (max-width: 768px) {
  .coming-soon__text {
    margin-top: 24px;
  }
  .main-hero {
    padding: 44px 0;
    h3 {
      font-size: 24px;
    }
    .input-email {
      display: grid;
      grid-template-columns: 1fr;
      justify-items: start;
      margin-bottom: 12px;
    }
    .single {
      display: contents;
      height: unset;
    }
  }
  .banner-img svg {
    height: 400px;
  }
}
@media (max-width: 640px) {
  .single {
    font-size: 32px;
  }
}
</style>
